import React from 'react'

import Card from '../shared/Card'
import Skeleton from '../shared/Skeleton'

const DETAIL_CARDS = [0, 1]

const DropdownRowSkeleton: React.FC = () => (
  <div className="w-full bg-white p-4 rounded-xl">
    <div className="flex items-center justify-between h-8">
      <Skeleton className="h-4 w-28 rounded" />
      <Skeleton className="h-3 w-3 rounded" />
    </div>
  </div>
)

const TrackingSkeleton: React.FC = () => (
  <div className="landscape:min-h-screen w-full portrait:px-4 portrait:py-2 text-sm" role="status" aria-busy="true">
    <span className="sr-only">Cargando la información de tu pedido</span>

    {/* Buscador */}
    <Card className="mb-4 portrait:hidden landscape:block">
      <div className="flex items-center gap-2">
        <div className="w-3/4 h-10 flex items-center gap-3 pl-2">
          <Skeleton className="w-4 h-4 rounded-full flex-shrink-0" />
          <Skeleton className="h-3.5 w-28 rounded" />
        </div>
        <Skeleton className="w-1/4 h-10 rounded-xl" />
      </div>
    </Card>

    {/* Estado del pedido */}
    <Card>
      {/* Seguimiento */}
      <Skeleton className="portrait:block landscape:hidden h-4 rounded mt-2 mx-2" />

      <div className="flex flex-col items-center mt-4">
        <Skeleton className="h-6 w-3/5 max-w-sm rounded mb-4" />
        <Skeleton className="h-4 w-2/5 max-w-[280px] rounded mb-5" />
        {/* UpdateComponent landscape */}
        <Skeleton className="h-4 w-1/3 max-w-[240px] rounded portrait:hidden landscape:block" />
      </div>

      {/* Timeline */}
      <div className="flex w-full justify-center my-10">
        <Skeleton className="h-2 w-1/2 rounded" />
      </div>

      {/* UpdateComponent portrait */}
      <div className="portrait:flex landscape:hidden flex-col gap-2.5 mt-8 mb-8 ml-10">
        <Skeleton className="h-3.5 w-20 rounded" />
        <Skeleton className="h-3.5 w-32 rounded" />
      </div>

      {/* StatusMapperComponent */}
      <div className="flex items-center justify-center gap-4 bg-[#F7F7F7] rounded-xl p-4 mx-2 mt-6">
        <Skeleton className="w-10 h-10 rounded-full flex-shrink-0" />
        <div className="flex flex-col gap-4">
          <Skeleton className="h-4 w-52 max-w-full rounded" />
          <Skeleton className="h-4 w-44 max-w-full rounded" />
        </div>
      </div>
    </Card>

    {/* Detalle */}
    <div className="landscape:mt-5 portrait:mt-5">
      <div className="flex items-center justify-between">
        <Skeleton className="h-3 w-12 rounded ml-4" />
        <Skeleton className="h-4 w-4 rounded-full mr-2 landscape:hidden" />
        {/* Ver Información */}
        <div className="portrait:hidden landscape:flex items-center gap-2">
          <Skeleton className="h-5 w-5 rounded-full flex-shrink-0" />
          <Skeleton className="h-3 w-24 rounded" />
        </div>
      </div>

      <div className="items-stretch portrait:flex min-w-full landscape:grid landscape:grid-cols-2 gap-3 mt-3 portrait:overflow-x-auto portrait:scrollbar-hide md:portrait:overflow-visible">
        {DETAIL_CARDS.map((card) => (
          <Card
            key={card}
            className="flex flex-col items-start gap-6 p-5 w-auto portrait:min-w-60 portrait:flex-shrink-0 md:portrait:flex-1 landscape:pt-5 landscape:pb-7"
          >
            <div className="flex items-center gap-2">
              <Skeleton className="w-4 h-4 rounded-full flex-shrink-0" />
              <Skeleton className="h-3.5 w-20 rounded" />
            </div>

            <div className="flex flex-col items-start gap-3 w-full">
              <Skeleton className="h-3 w-28 rounded" />
              <Skeleton className="h-3 w-24 rounded" />
              <Skeleton className="h-3 w-40 rounded" />
            </div>
          </Card>
        ))}
      </div>
    </div>

    {/* Desplegables */}
    <div className="mt-4">
      <DropdownRowSkeleton />
    </div>

    <div className="mt-4">
      <DropdownRowSkeleton />
    </div>
  </div>
)

export default TrackingSkeleton
